import React from 'react';
import { Switch, Route, Redirect, Router } from 'react-router-dom';
import App from '_common_old/containers/App';
import history from '_common_old/history';

import routeMap from './RouteMap';

export default (
  <Router history={history}>
    <App>
      <Switch>
        {routeMap.map((item, index) => {
          return (
            <Route
              key={index}
              path={item.path}
              exact={item.exact}
              component={
                item.redirect
                  ? () => {
                      return <Redirect to={item.redirect} />;
                    }
                  : item.component
              }
            />
          );
        })}
      </Switch>
    </App>
  </Router>
);
